module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-modal-footer"
  }, [_c('button', {
    staticClass: "modal-button-newSearch",
    on: {
      "click": function($event) {
        return _vm.$emit('ClickHandlerContinue')
      }
    }
  }, [_vm._v("\n          Pesquisar novamente\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-button-manualInsert",
    on: {
      "click": function($event) {
        return _vm.$emit('ClickHandlerCancel')
      }
    }
  }, [_vm._v("\n          Cadastrar veículo manualmente\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-modal-header"
  }, [_c('h1', {
    staticStyle: {
      "color": "#8a6d3b"
    }
  }, [_vm._v("Atenção!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-modal-body"
  }, [_c('div', {
    staticClass: "form-modal-container"
  }, [_c('div', {
    staticClass: "form-modal-description"
  }, [_c('p', {
    staticClass: "modal-text"
  }, [_vm._v("\n              Não foi possível consultar os dados do veículo nesse momento.\n              Por favor, pesquise novamente ou faça o cadastro manualmente.\n            ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-773cdac7!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Adhesion/form-modal/form-modal-new-search.vue
// module id = 2172
// module chunks = 1